<div class="container mt-2">
    <form id="fmc_master" [formGroup]="deliveryChallanSearch" (ngSubmit)="deliveryChalanSearch()">
        <div class="card mt-3">
            <div class="row d-flex  justify-content-center align-items-center">
                <div class="row d-flex  justify-content-center align-items-center ">
                    <div class="col-12 col-sm-6 col-lg-3 mb-3">
                        <div class="form-group three">
                            <label class="form-label label-custom">Sale Date</label>
                            <input type="date" formControlName="sale_date" class="form-control"
                                placeholder="12-08-2023" />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3 mb-3">
                        <div class="form-group three">
                            <label class="form-label label-custom fieldRequired">GA Name</label>
                            <ng-select class="custom" name="ga_code" [items]="GA" bindLabel="name_of_ga"
                                bindValue="ga_code" formControlName="ga_code" placeholder="Select GA Name"
                                (change)="getPlantCode($event)">
                            </ng-select>
                            <app-field-error-display
                                [displayError]="isFieldValid('ga_code') && deliveryChallanSearch.controls['ga_code'].errors?.['required']"
                                errorMsg="GA Name is required"></app-field-error-display>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3 mb-3">
                        <div class="form-group three">
                            <label class="form-label label-custom">SAP Plant Code/ Customer Code</label>
                            <ng-select [items]="PlantCodeDropDown" bindValue="source_plant_code" bindLabel="plant_code_concat"
                                formControlName="source_plant_code" placeholder="Select Plant Code" [multiple]="false"
                                [closeOnSelect]="false" [searchable]="true">
                            </ng-select>
                            <app-field-error-display
                                [displayError]="isFieldValid('source_plant_code') && deliveryChallanSearch.controls['source_plant_code'].errors?.['required']"
                                errorMsg="SAP Plant Code is required"></app-field-error-display>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3 mb-3">
                        <div class="form-group three">
                          <label for="exampleInputEmail1" class="form-label label-custom fieldRequired">Vehicle Number</label>
                          <ng-select
                            [items]="sortedVehicleMasterList"
                            bindValue="vehicle_no"
                            bindLabel="vehicle_no"
                            formControlName="vehicle_number"
                            placeholder="Select Vehicle Number"
                            (change)="onVehicleNumberChange($event)"
                            >
                          </ng-select>
                          <app-field-error-display
                            [displayError]="isFieldValid('vehicle_number') && deliveryChallanSearch.controls['vehicle_number'].errors?.['required']"
                            errorMsg="Vehicle Number is required">
                          </app-field-error-display>
                        </div>
                      </div>
                    <div class="col-12 col-sm-12   d-flex  justify-content-center align-items-center">
                        <div class="form-group mt-1 mb-4">

                            <button type="submit" class="btn btnsubmit-custom">Search</button>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </form>

    <div class="row   align-items-start bg-formcustom">
        <div class="table-searchDatatable p-0">

            <div class="table-responsive ">
                <table class="" cellspacing="0" cellpadding="0">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 300px;">Sr No.</th>
                            <th scope="col" style="width: 300px;">Select</th>
                            <th scope="col" style="width: 300px;">Seq No</th>
                            <th scope="col" style="width: 120px;">SAP Plant Code</th>
                            <th scope="col" style="width: 600px;">SAP Plant</th>
                            <th scope="col" style="width: 300px;">Vehicle Numbers</th>
                            <th scope="col" style="width: 300px;">Qty Filled (KG)</th>
                            <th scope="col" style="width: 300px;">Movement Type</th>
                            <th scope="col" style="width: 300px;">Destination/SAP plant Code</th>
                        </tr>
                    </thead>                    
                    <tbody>
                        @for (item of challanSearchData; track $index) {

                        <tr>
                            <td>
                                {{$index+1}}
                            </td>
                            <td>
                                <div class="d-flex justify-content-center">
                                    <!-- <input type="checkbox" [checked]="selectedOption === item.sequence_no"
                                    (change)="onCheckboxChange(item)" /> -->
                                    <div class="customeCheck widthCheck">
                                        <input type="checkbox" id="checkbox-{{$index}}" type="checkbox"
                                            [checked]="selectedOption === item.sequence_no"
                                            (change)="onCheckboxChange(item)">
                                        <label for="checkbox-{{$index}}"></label>
                                    </div>
                                </div>
                            </td>
                            <td>{{item?.sequence_no}}</td>
                            <td>{{item?.source_plant_code}}</td>
                            <td>{{item?.plant_name}}</td>
                            <td>{{item?.vehicle_number}}</td>
                            <td>{{item?.quantity_filled?.toFixed(3)}}</td>
                            <td>{{(item?.movement_type)}}</td>
                            <td>{{(item?.destination_plant_code) }}</td>
                        </tr>}

                    </tbody>
                </table>
            </div>
        </div>

        <form id="fmc_master" [formGroup]="deliveryChallan" (ngSubmit)="deliveryChalanSubmit()">
            <div class="card backgroundTransparent">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-5 mb-3 mt-3">
                        <div class="form-group">
                            <label for="exampleInputEmail1" class="form-label label-custom">SAP Plant Code</label>
                            <input formControlName="source_plant_code" type="text" class="form-control"
                                placeholder="Auto fetch" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-5 mb-3 mt-3">
                        <div class="form-group">
                            <label for="exampleInputEmail1" class="form-label label-custom">Seq No</label>
                            <input formControlName="sequence_no" type="text" class="form-control"
                                placeholder="Auto fetch" />
                        </div>
                    </div>
                    <!-- <div class="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                <div class="form-group">
                    <label for="exampleInputEmail1" class="form-label label-custom">Vehicle numbers</label>
                    <input type="text" class="form-control" />
                </div>
            </div> -->
                    <!-- <div class="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                <div class="form-group">
                    <label for="exampleInputEmail1" class="form-label label-custom">From Station</label>
                    <input type="text" placeholder="Auto fetch" class="form-control" />
                </div>
            </div> -->
                    <!-- <div class="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                <div class="form-group">
                    <label for="exampleInputEmail1" class="form-label label-custom">To Station</label>
                    <input type="text" class="form-control" placeholder="Auto fetch" />
                </div>
            </div> -->

                    <div class="col-12 col-md-2 col-lg-2 mb-3 mt-3">
                        <div class="form-group">
                            <br />

                            <button type="submit" class="btn btnsubmit-custom btnsubmitCustomFilter">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="row mt-5">
        <div class="table-datashowCust">
            <div class="title-tav-inner-section">
                <h3>Delivery Challan</h3>
            </div>
            <div class="table-responsive ">
                <table class="table table-bordered mb-0">
                    <thead>

                        <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">SAP Plant Code</th>
                            <th scope="col">Seq No</th>
                            <th scope="col">Vehicle numbers</th>
                            <th scope="col">From Station</th>
                            <th scope="col">To Station</th>
                            <th scope="col">Delivery Challan</th>
                            <th scope="col">Receipt</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of deliveryChallanData; track $index) {
                        <tr>
                            <td>{{$index+1}}</td>
                            <td>{{item?.sender_details?.source_plant_code}}</td>
                            <td>{{item?.sequence_no}}</td>
                            <td>{{item?.vehicle_number}}</td>
                            <td>{{item?.sender_details?.sender_station_name}}</td>
                            <td>{{item?.receiver_details?.receiver_station_name}}</td>
                            <td>
                                <button class="btn editBtn" (click)="previewPDF()" data-bs-toggle="modal"
                                    data-bs-target="#pdfModal">
                                    <i class="bi bi-eye-fill bi-custom"></i>
                                </button>
                            </td>
                            <td>
                                <button class="btn editBtn" target="_blank" (click)="generatePDF()">
                                    <i class="bi bi-download"></i>
                                </button>
                            </td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        </div>
    </div>


</div>



<!-- Modal -->
<div class="modal fade" id="pdfModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content pdf-section">
            <div class="modal-header">

                <button type="button" class="btn-closes" data-bs-dismiss="modal" aria-label="Close"><i
                        class="bi bi-x"></i></button>
            </div>
            <div class="modal-body">
                <div class="pdf-wraap" *ngIf="pdfSrc">
                    <div class="pdf-preview">
                        <iframe [src]="pdfSrc|safe" width="100%" height="500px"></iframe>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<div id="pdfContent" class="content" *ngIf="isShowHide">
    <table style="  width: 90%;margin: auto; ">
        <tr>
            <td>
                <table style="  width: 100%;">
                    <tr>
                        <td>
                            <div style="padding: 5px;">
                                <img src="./images/gail-gas.png" />
                            </div>
                        </td>
                        <td style="border-right: none;">
                            <table style="  width: 100%;">
                                <tr>
                                    <td>
                                        <h3 style="text-align: center; font-weight: 600; font-size: 30px;margin: 5px;">
                                            GAIL GAS Limited</h3>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p
                                            style="text-align: center; font-weight:600; color:#000; font-size:20px; padding: 2px 0px; margin: 5px;">
                                            <!-- 3rd Floor, M.S. Complex, S-44, New BEL Road, Bengaluru-560
                                            054
                                            city : "Bengaluru,Karnataka560091" -->
                                            {{challanObj?.sender_details?.source_plant_code}}
                                            {{challanObj?.sender_details?.sender_station_name}}
                                            {{challanObj?.sender_details?.address_1}}
                                            {{challanObj?.sender_details?.address_2}}
                                            {{challanObj?.sender_details?.address_3 }}
                                            <!-- {{challanObj?.sender_details?.source_plant_code }}
                                            {{challanObj?.sender_details?.sender_station_name }} -->
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5 style="text-align: center; font-weight: 600; font-size: 26px;">
                                            DELIVERY CHALLAN - {{this.constants.MomentType[this.momentType]}}
                                        </h5>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="width: 100%; padding: 10px 0px;">
                <table class="challanTable" style="width: 100%;">
                    <tr>
                        <td style="width: 40%; padding: 0px; border: 2px solid #000; border-right:none;">
                            <table>
                                <tr>
                                    <td class="challanTableSubheading"
                                        style="border: none !important; padding: 5px !important;font-weight: 600; font-size:18px;">
                                        Challan No. <span></span>
                                    </td>
                                    <td style="
                      border: none !important ;
                      padding: 5px !important;
                      font-size: 30px;
                      font-weight: 600;
                    ">
                                        {{challanObj?.sequence_no }}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="
                      border: none !important;
                      padding: 5px !important;
                      font-weight: 600; font-size:18px;
                    ">
                                        Challan Date
                                    </td>
                                    <td style="
                      border: none !important;
                      padding: 5px !important;
                      font-weight: 600; font-size:18px;
                    ">
                                        {{ challanObj?.filling_end_time| date: 'dd-MM-yyy' }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style=" border: 2px solid #000;">
                            <table style="width: 100%; border: none !important;">
                                <tr>
                                    <td class="challanTableSubheading"
                                        style="border: none !important; padding: 5px !important; font-weight: 600;  font-size:18px;">
                                        Date and Time of Removal of Goods
                                    </td>
                                    <td style="border: none !important; padding: 5px !important">
                                        <table style="width: 100%; border: none">
                                            <tr>
                                                <td
                                                    style="width: 100%; border: none; padding: 5px; font-weight: 600;  font-size: 16px;">
                                                    {{ challanObj?.filling_end_time| indianDate }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    style="width: 100%; border: none; padding: 5px;font-weight: 600; font-size: 16px;">
                                                    {{ challanObj?.filling_end_time | indianTimeMoment }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="width: 100%; padding:10px 0px;">
                <table style="width: 100%; border: 2px solid #000">
                    <tr>
                        <td style="width: 40%; padding: 0px">
                            <table style="border: none !important; width: 100%">
                                <tr>
                                    <td class="challanTableSubheading"
                                        style="border: none !important; font-size: 18px; color:#000; font-weight: 600; padding: 5px !important">
                                        Sender:
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important; font-size: 20px; font-weight: 600;">
                                        GAIL Gas Limited- Mother Station
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                        {{challanObj?.sender_details?.source_plant_code }}
                                        {{challanObj?.sender_details?.sender_station_name}}
                                        {{challanObj?.sender_details?.address_1}}
                                        {{challanObj?.sender_details?.address_2}}
                                        {{challanObj?.sender_details?.address_3 }}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                        GSTIN: <span> {{challanObj?.sender_details?.gstin}} </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 13px; font-weight: 600;">
                                        VAT: <span> {{challanObj?.sender_details?.vat}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                        Excise No.: <span> {{challanObj?.sender_details?.excisenumber}} </span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table style="border: none !important; width: 100%">
                                <tr>
                                    <td style="
                      border: none !important;
                      padding: 5px !important;
                      font-size: 18px;
                      font-weight: 600;
                    ">
                                        Receiver:
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 18px; font-weight: 600;">
                                        {{challanObj?.receiver_details?.receiver_station_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        style="border: none !important; padding: 5px !important;font-size: 18px; font-weight: 600;">
                                        {{challanObj?.receiver_details?.destination_plant_code }}
                                        {{challanObj?.receiver_details?.receiver_station_name }}
                                        {{challanObj?.receiver_details?.address_1}}
                                        {{challanObj?.receiver_details?.address_2}}
                                        {{challanObj?.receiver_details?.address_3 }}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="
                      border: none !important;
                      padding: 0px !important;
                      width: 100% !important;
                    ">
                                        <table style="width: 100%; padding: 0px">
                                            <tr>
                                                <td style="border: none; padding: 0px">
                                                    <table style="border: none; padding: 0px">
                                                        <tr>
                                                            <td
                                                                style="border: none; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                                                GSTIN: {{challanObj?.receiver_details?.gstin}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="border: none; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                                                VAT: {{challanObj?.receiver_details?.vat}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="border: none; padding: 5px !important;font-size: 16px; font-weight: 600;">
                                                                Excise No.:  {{challanObj?.receiver_details?.excisenumber}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td style="
                            width: 40% !important;
                            padding: 0px;
                            border-top: 2px solid #000;
                            border-left: 2px solid #000;
                      
                            border-bottom: none;
                          ">
                                                    <table style="border: none; padding: 10px; width: 100%">
                                                        <tr>
                                                            <td style="
                                  border: none;
                                  padding: 10px 10px 0px !important;font-size: 16px; font-weight: 600;
                                ">
                                                                Vehicle No.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                style="border: none; padding: 10px !important;font-size: 16px; font-weight: 600;">
                                                                {{challanObj?.vehicle_number}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="width: 100%; padding: 10px 0">
            <table style="width: 80%; margin: auto; border: 2px solid #000">
                <tr>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Description</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Opening/Start</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Closing/End</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Diff</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">UoM</td>
                </tr>

                <!-- Flow Meter -->
                <tr>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Flow Meter</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ (challanObj?.meter_reading?.initial)?.toFixed(3)  }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ (challanObj?.meter_reading?.final)?.toFixed(3) }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ (challanObj?.meter_reading?.final | subtract: challanObj?.meter_reading?.initial) | number:'1.3-3' }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">KG</td>
                </tr>

                <!-- Pressure -->
                <tr>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Pressure</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ challanObj?.in_pressure }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ challanObj?.out_pressure }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ (challanObj?.out_pressure | subtract: challanObj?.in_pressure) | number:'1.3-3' }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Bar</td>
                </tr>

                <!-- Filling Time -->
                <tr>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Filling Time</td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ challanObj?.filling_start_time | indianDate }}{{" "}}{{ challanObj?.filling_start_time | indianTimeMoment }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                    {{ challanObj?.filling_end_time | indianDate }}{{" "}}{{ challanObj?.filling_end_time | indianTimeMoment }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">
                {{ challanObj?.filling_start_time | timeDiff: challanObj?.filling_end_time }}
                </td>
                <td style="border: 1px solid #000; padding: 10px; font-size: 16px; font-weight: 600; text-align: center;">Hrs</td>
                </tr>
            </table>
            </td>
        </tr>
        <tr>
            <td style="width: 100%; padding: 10px 0px">
                <table style="width: 100%; border: 2px solid #000">
                    <tr>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">Sl.No.</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">
                            Description</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">Qty</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">Rate</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">Amount</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">1</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">CNG</td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">
                            {{challanObj?.amount?.quantity}}
                        </td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">
                            {{challanObj?.amount?.rate}}
                        </td>
                        <td style="border: 1px solid #000; padding: 10px;font-size: 16px; font-weight: 600;">
                            {{challanObj?.amount?.amount}}
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="width: 100%; padding: 10px 0px; border: 2px solid #000">
                <table>
                    <tr>
                        <td style="padding: 10px;font-size: 18px; font-weight: 600;">
                            We hereby certify that the certificate under the applicable state act is in force on the date which the transaction of above this bill has been affected by us.
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 10px;font-size: 18px; font-weight: 600;">
                            Certified that the particulars given above are true and correct
                            and the amount indicated represents the price actually charged and
                            that there is no flow of additional consideration directly or
                            indicrectly.
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 10px;font-size: 18px; font-weight: 600;">
                            All the applicable taxes have been already paid.
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 10px;font-size: 18px; font-weight: 600;">For GAIL Gas Limited</td>
                    </tr>
                    <tr>
                        <td style="padding: 10px;font-size: 18px; font-weight: 600;">
                            ***This is system generated document and hence does not
                            require any signature***
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>